export const NO_STOP_INDEX = -1;
